export const CONTACT_CONFIG = {
  email: 'contact@cantecelulmeu.ro',
  //phone: '+40761375973',
  //whatsapp: '+40761375973',
  address: 'Strada Exemplu 123, București, România',
  facebook: 'https://www.facebook.com/cantecelulmeu',
  instagram: 'https://www.instagram.com/cantecelulmeu',
} as const;